/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react'

import ReactCrop, {   centerCrop,
  makeAspectCrop, Crop, PixelCrop } from 'react-image-crop'
import { useDebounceEffect } from './useDebounceEffect'

import { Button, Modal, Spin, Divider, Collapse } from 'antd';

// import Jimp from 'jimp';

const { Panel } = Collapse;

import 'react-image-crop/dist/ReactCrop.css'

const CropImage = (props) => {
  const [imgSrc, setImgSrc] = useState('')
  const previewCanvasRef = useRef(null)
  const imgRef = useRef(null)
  const [crop, setCrop] = useState({
    unit: '%', // Can be 'px' or '%'
    x: 0,
    y: 0,
    width: 100,
    height: 100
  })
  const [completedCrop, setCompletedCrop] = useState(
    {
      unit: '%', // Can be 'px' or '%'
      x: 0,
      y: 0,
      width: 100,
      height: 100
    }
  )
  const [scale, setScale] = useState(1)
  const [rotate, setRotate] = useState(0)


  // function onSelectFile(e) {
  //   if (e.target.files && e.target.files.length > 0) {
  //     setCrop(undefined) // Makes crop preview update between images.
  //     const reader = new FileReader()
  //     reader.addEventListener('load', () =>
  //       setImgSrc(reader.result.toString() || ''),
  //     )
  //     reader.readAsDataURL(e.target.files[0])
  //   }
  // }

  function onImageLoad(e) {
    imgRef.current = e.currentTarget

    const { width, height } = e.currentTarget

    // This is to demonstate how to make and center a % aspect crop
    // which is a bit trickier so we use some helper functions.
    // const crop = centerCrop(
    //   makeAspectCrop(
    //     {
    //       unit: '%',
    //       width: 90,
    //     },
    //     16 / 9,
    //     width,
    //     height,
    //   ),
    //   width,
    //   height,
    // )

    // setCrop(crop)

    // if (props.file) {
    //   setCrop(undefined) // Makes crop preview update between images.
    //   const reader = new FileReader()
    //   reader.addEventListener('load', () =>
    //     setImgSrc(reader.result.toString() || ''),
    //   )
    //   reader.readAsDataURL(props.file)
    // }


  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        // canvasPreview()
        // imgRef.current,
        // previewCanvasRef.current,
        // completedCrop,
        // scale,
        // rotate,
      }
    },
    100,
    [completedCrop, scale, rotate],
  )

  const fitToContainer = (imageWidth, imageHeight) => {
    const canvasScroll = document.getElementById("canvasScroll");
    const containerWidth = canvasScroll.offsetWidth;
    const containerHeight = canvasScroll.offsetHeight;


    var scaledImageHeight = imageHeight;
    var scaledImageWidth = imageWidth;

    let scale = Math.min(
      containerWidth / imageWidth,
      containerHeight / imageHeight
    );



    if (scale < 1) {
      console.log("true");
      scaledImageHeight = Math.floor(imageHeight * scale);
      scaledImageWidth = Math.floor(imageWidth * scale);
      props.setScale(scale);
      console.log("the scale is: ",scale);
    }

    return [scaledImageWidth, scaledImageHeight];
  }

  return (



    <div className="test">

      <Modal
        title="Crop Image"
        visible={props.isModalVisible}
        onOk={() => {  }}
        onCancel={() => { props.setIsModalVisible(false)}}
        footer={[
          <Button key="back" onClick={() => { 



            const img = new Image();
            img.onload = function () {

              console.log("completedCrop: ", completedCrop);

              const newCrop = {
                unit: 'px', // Can be 'px' or '%'
                x: img.width*(completedCrop.x/100),
                y: img.height*(completedCrop.y/100),
                width: img.width*(completedCrop.width/100),
                height: img.height*(completedCrop.height/100)
              };
              
              props.setCropGlobal(newCrop);

              const canvas = document.getElementById("canvas");
        
              const [imgWidth, imgHeight] = fitToContainer(newCrop.width, newCrop.height);  
        
              canvas.width = imgWidth;
              canvas.height = imgHeight;
        
              canvas.getContext("2d").drawImage(img, newCrop.x,  (newCrop.y),  (newCrop.width),  (newCrop.height), 0, 0,  (imgWidth),  (imgHeight));
              props.setImageDimensions([newCrop.width, newCrop.height]);
              props.setIsModalVisible(false)
              // props.setDespeckle(completedCrop.width * 0.01);
            }
        
            img.src = URL.createObjectURL(props.file);
            
           }} >
            Save
          </Button>,

          // <Button key="downloadSVG" loading={props.isLoading} type="primary" onClick={() => { handleOk(); }} >
          //   Download SVG
          // </Button>
          // ,
        ]}
      >
      <div>
        {/* <input type="file" accept="image/*" onChange={onSelectFile} />
        <div>
          <label htmlFor="scale-input">Scale: </label>
          <input
            id="scale-input"
            type="number"
            step="0.1"
            value={scale}
            disabled={!imgSrc}
            onChange={(e) => setScale(Number(e.target.value))}
          />
        </div>
        <div>
          <label htmlFor="rotate-input">Rotate: </label>
          <input
            id="rotate-input"
            type="number"
            value={rotate}
            disabled={!imgSrc}
            onChange={(e) =>
              setRotate(Math.min(180, Math.max(-180, Number(e.target.value))))
            }
          />
        </div> */}
      </div>
      {Boolean(URL.createObjectURL(props.file)) && (
        <ReactCrop
          crop={crop}
          ruleOfThirds={true}
          onChange={(_, percentCrop) => {
            setCrop(percentCrop)
          }}
          onComplete={(c, percentCrop) => {
            setCompletedCrop(percentCrop)
          }
          }
        >
          <img
            alt="Crop me"
            src={URL.createObjectURL(props.file)}
            // style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
            onLoad={onImageLoad}
          />
        </ReactCrop>
      )}
      </Modal>



    </div>
  )
}


export default CropImage;